import { Outlet } from 'react-router-dom'
import { FC } from 'react'

import { Loader } from '../Loader'
import { useAppInitializer } from './hooks/useAppInitializer'

export const App: FC = () => {
  const { loading } = useAppInitializer()

  if (loading) {
    return <Loader />
  }

  return <Outlet />
}
